/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Oauth_Success_DescriptionInputs */



/**
* | output |
* | --- |
* | "The space name and provider are locked and cannot be changed after OAuth authentication." |
*
* @param {Spaces_Oauth_Success_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_oauth_success_description = /** @type {((inputs?: Spaces_Oauth_Success_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Oauth_Success_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Raumname und der Anbieter sind nach der OAuth-Authentifizierung gesperrt und können nicht geändert werden.")
	return /** @type {LocalizedString} */ ("The space name and provider are locked and cannot be changed after OAuth authentication.")
});